import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AlertModal } from 'src/app/app.model';
import { DataSharedService } from '../../services/data-shared.service';

import { ClientService } from 'src/app/services/client.service';
import { AlertModalComponent } from '../alert-modal/alert-modal.component';
import { AuthenticationService } from 'src/app/services/authentication.service';
declare var angular: any;

@Component({
	selector: 'app-create-client',
	templateUrl: './create-client.component.html',
	styleUrls: ['./create-client.component.css']
})
export class CreateClientComponent implements OnInit {

	error!: string;
	loading: boolean = false;

	formValid: boolean = false;
	clientForm: FormGroup | any;
	defaultVat: number = 0;

	email_type: number = 0;
	frequency: number = 1;
	day_to_receive: number = 1;
	time_to_receive: string = '17:00';
	clientformValid: boolean = false;

	activeSubpanel: 'details' | 'contacts' = 'details';
	openContacts: Set<number> = new Set<number>();

	client_contacts: any[] = [];

	constructor(
		private clientService: ClientService,
		public authService: AuthenticationService,
		public dataSharedService: DataSharedService,
		private modalService: NgbModal,
		private activeModalService: NgbActiveModal
	) { }

	ngOnInit(): void {
		this.clientForm = new FormGroup({
			name: new FormControl('', Validators.required),
			identifier: new FormControl('', []),
			address_1: new FormControl('', Validators.required),
			address_2: new FormControl('', []),
			post_zip_code: new FormControl('', []),
			country: new FormControl('', []),
			payment_terms: new FormControl('', []),
			is_vat_applicable: new FormControl(0, []),
			invoice_email: new FormControl('', []),
			client_company_number: new FormControl('', []),
			client_reference: new FormControl('', []),
			currency_format: new FormControl('', []),
		});

		this.client_contacts.push(this.makeEmptyContact());
		this.openContacts.add(0);
		this.ClientContactValidation(null);
	}

	private makeEmptyContact(): any {
		return {
			uuid: this.client_contacts.length + 1,
			first_name: '',
			last_name: '',
			email: '',
			send_invite: true,
			timesheet_notification_settings: {
				email_type: this.email_type,
				frequency: this.frequency,
				day: this.day_to_receive,
				time: this.time_to_receive,
			}
		};
	}

	setSubpanel(panel: 'details' | 'contacts') {
		this.activeSubpanel = panel;
	}

	setVat(v: number) {
		this.clientForm.get('is_vat_applicable')?.setValue(v);
	}

	toggleContact(i: number) {
		if (this.openContacts.has(i)) {
			this.openContacts.delete(i);
		} else {
			this.openContacts.add(i);
		}
	}

	addContact() {
		this.client_contacts.push(this.makeEmptyContact());
		const newIdx = this.client_contacts.length - 1;
		this.openContacts.clear();
		this.openContacts.add(newIdx);
		this.ClientContactValidation(null);
	}

	removeContact(i: number, evt?: Event) {
		if (evt) {
			evt.stopPropagation();
		}
		this.client_contacts.splice(i, 1);
		const rebuilt = new Set<number>();
		this.openContacts.forEach(idx => {
			if (idx < i) rebuilt.add(idx);
			else if (idx > i) rebuilt.add(idx - 1);
		});
		this.openContacts = rebuilt;
		this.error = '';
		this.ClientContactValidation(null);
	}

	getInitials(contact: any): string {
		const f = (contact?.first_name || '').trim();
		const l = (contact?.last_name || '').trim();
		const initials = (f.charAt(0) + l.charAt(0)).toUpperCase();
		return initials || '?';
	}

	dayName(d: number): string {
		return ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'][d] || '—';
	}

	onClose() {
		const modalRef = this.modalService.open(AlertModalComponent, {
			size: 'md',
			backdrop: false,
			modalDialogClass: 'alert-modal modal-dialog-centered',
		});

		let data: AlertModal = {
			message: 'Are you sure you want to discard Client Creation?',
			yesAction: 'Discard',
			yesActionColor: '#0566EA',
			noAction: 'Cancel',
			noActionColor: 'transparent',
		}
		modalRef.componentInstance.data = data;
		modalRef.result.then((data) => {
			if (data?.action === 'yes') {
				this.activeModalService.close();
			}
		});
	}

	ValidateEmail(email: string) {
		let email_regexp = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
		return email_regexp.test(email);
	}

	async ClientContactValidation(event: any) {
		this.error = '';
		let hasErr = false;

		if (this.client_contacts.length === 0) {
			hasErr = true;
		}

		for (const c of this.client_contacts) {
			if (!c.first_name || c.first_name.trim() === '') { hasErr = true; break; }
			if (!c.last_name || c.last_name.trim() === '') { hasErr = true; break; }
			if (!c.email || c.email.trim() === '') { hasErr = true; break; }
			if (!this.ValidateEmail(c.email.trim())) { hasErr = true; break; }
			if (c.timesheet_notification_settings.email_type === 1) {
				const t = c.timesheet_notification_settings.time;
				if (!t || (typeof t === 'string' && t.trim() === '')) { hasErr = true; break; }
			}
		}

		this.clientformValid = !hasErr;
	}

	async clientValidation(event: any) {
		this.error = '';
		let hasErr = false;
		if (this.clientForm.controls.name.errors ||
			(this.clientForm.controls.name.value || '').trim() === '') {
			hasErr = true;
		}

		if (hasErr) {
			this.formValid = false;
		} else {
			this.formValid = true;
		}
	}

	onSubmit() {
		this.loading = true;
		let client_address = {
			'address_1': this.clientForm.value.address_1,
			'address_2': this.clientForm.value.address_2,
			'post_zip_code': this.clientForm.value.post_zip_code,
			'country': this.clientForm.value.country,
		};

		const enrichedContacts = this.client_contacts.map(c => ({
			...c,
			name: `${c.first_name || ''} ${c.last_name || ''}`.trim(),
		}));

		const payload = { client: this.clientForm.value, client_contacts: enrichedContacts, address: client_address };
		this.clientService.createClient(payload).subscribe(response => {
			this.activeModalService.close({
				refresh: true,
				client_response: response
			});

			this.loading = false;
		}, error => {
			this.loading = false;
			this.error = error;
		});
	}
}
